const PartnerActionTypes = {
  LOAD_FILE_IMPORT: 'partner/load_file_import',
  NEXT_STEP: 'partner/next_step',
  PREV_STEP: 'partner/prev_step',
  CANCEL_IMPORT: 'partner/cancel_import',
  LOADING: 'partner/loading',
  UPDATE_DATA_IMPORT: 'partner/update_data_import',
};

export default PartnerActionTypes;